export const INSTAGRAM_POST_TAG_PRODUCT_TYPE = "product";
export const INSTAGRAM_POST_TAG_LINK_TYPE = "link";

export const INSTAGRAM_POST_MEDIA_VIDEO_TYPE = "video";
export const INSTAGRAM_POST_MEDIA_IMAGE_TYPE = "image";
export const INSTAGRAM_STORIES_MEDIA_VIDEO_TYPE = "video";
export const INSTAGRAM_STORIES_MEDIA_IMAGE_TYPE = "image";
export const INSTAGRAM_GRID_LAYOUT = "grid";
export const INSTAGRAM_LISTING_LAYOUT = "listing";
export const INSTAGRAM_SLIDE_LAYOUT = "slide";
export const INSTAGRAM_MASONRY_LAYOUT = "masonry";

export const INSTAGRAM_MODAL_REFERRER = "instagram-modal";

export const INSTAGRAM_TRACKING_APP_NAME = "instagram";

// SLIDER_RESIZE_DELAY - нужен для того, чтоб задать задержку при изменении окна браузера.
// Зачем она нужна? -При резком изменении окна браузера event(resize) не успевал отработать.
export const SLIDER_RESIZE_DELAY = 170;
